import React from 'react';

import { BaseLayoutProps } from './BaseLayout.types';
import {
  WithHeaderSidebarFooter,
  WithHeaderSidebar,
  WithHeaderFooter,
  WithSidebarFooter,
  WithHeader,
  WithSidebar,
  WithFooter,
  WithoutHeaderSidebarFooter,
} from './BaseLayout.styles';

const BaseLayout = ({
  sidebarWidth = undefined,
  backgroundColor,
  children,
  header,
  sidebar,
  footer,
  px = [4, 4, 8, 8],
  py = [6, 6, 8, 8],
  ...rest
}: BaseLayoutProps) => {
  if (header && sidebar && footer) {
    return (
      <WithHeaderSidebarFooter
        sidebarWidth={sidebarWidth}
        backgroundColor={backgroundColor}
        {...rest}
        px={px}
        py={py}
      >
        {header}

        {sidebar}

        <main>{children}</main>

        {footer}
      </WithHeaderSidebarFooter>
    );
  }

  if (header && sidebar && !footer) {
    return (
      <WithHeaderSidebar
        sidebarWidth={sidebarWidth}
        backgroundColor={backgroundColor}
        {...rest}
        px={px}
        py={py}
      >
        {header}

        {sidebar}

        <main>{children}</main>
      </WithHeaderSidebar>
    );
  }

  if (sidebar && footer && !header) {
    return (
      <WithSidebarFooter
        sidebarWidth={sidebarWidth}
        backgroundColor={backgroundColor}
        {...rest}
        px={px}
        py={py}
      >
        {sidebar}

        <main>{children}</main>

        {footer}
      </WithSidebarFooter>
    );
  }

  if (header && footer && !sidebar) {
    return (
      <WithHeaderFooter backgroundColor={backgroundColor}>
        {header}

        <main>{children}</main>

        {footer}
      </WithHeaderFooter>
    );
  }

  if (header && !sidebar && !footer) {
    return (
      <WithHeader backgroundColor={backgroundColor}>
        {header}

        <main>{children}</main>
      </WithHeader>
    );
  }

  if (sidebar && !header && !footer) {
    return (
      <WithSidebar sidebarWidth={sidebarWidth} backgroundColor={backgroundColor} px={px} py={py}>
        {sidebar}

        <main>{children}</main>
      </WithSidebar>
    );
  }

  if (footer && !header && !sidebar) {
    return (
      <WithFooter backgroundColor={backgroundColor}>
        <main>{children}</main>

        {footer}
      </WithFooter>
    );
  }

  return (
    <WithoutHeaderSidebarFooter backgroundColor={backgroundColor}>
      <main>{children}</main>
    </WithoutHeaderSidebarFooter>
  );
};

export default BaseLayout;
